<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>
          <a @click="$functions.historyBack()" style="cursor: pointer">{{$t('factory.title')}}</a>
          <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> 
          {{$t('factory.users.title')}}
        </h2>
        <div class="irinox-form factory-form" >
          <TabView>
            <TabPanel :header="$t('factory.tab_users')">
              <Users :serialNumber="$route.params.serialNumber"/>
            </TabPanel>
          </TabView>
        </div>
		</div>
	</div>

</template>

<script>
import Users from './Users.vue';
export default {
  
    components: {
      Users
    },
    data() {
        return {
        };
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style>

</style>